import { Group, useMantineTheme } from '@mantine/core';
import { IconPoint } from '@tabler/icons-react';
import { EvidenceFieldRow } from 'components/tables/data/evidence-field/types';
import P2Regular from 'components/typography/P2Regular';

/**
 * Column for the evidence field required status.
 */
export default function IsRequiredColumn({ data: { isRequired } }: { data: EvidenceFieldRow }) {
  const theme = useMantineTheme();

  const color = isRequired ? theme.colors.red[8] : theme.colors.gray[6];

  return (
    <Group>
      <Group position="center" style={{ borderRadius: '50%' }} bg={isRequired ? 'red.1' : 'gray.1'} h={24} w={24}>
        <IconPoint fill={color} color={color} size={16} />
      </Group>
      <P2Regular color={color}>{isRequired ? 'Povinné' : 'Nepovinné'}</P2Regular>
    </Group>
  );
}
